function updatePredictionsDropDownDisplay(dropDown, input) {
	if(typeof input.offset() == 'undefined') {
	return false;
	}
	dropDown.css({
	'width': input.outerWidth(),
	'left': input.offset().left,
	'top': input.offset().top + input.outerHeight()
	});
}

(function ( $ ) {
	$.fn.positionCityAutocomplete = function() {
			var predictionsDropDown = $('.city-autocomplete');
			var input = this;
			updatePredictionsDropDownDisplay(predictionsDropDown, input);
	};

	$.fn.cityAutocomplete = function(options) {
		options = options || {};

		var autocompleteService = new google.maps.places.AutocompleteService();
		var predictionsDropDown = $('<div class="city-autocomplete"></div>').appendTo('body');
		var input = this;

		var typingTimer;                //timer identifier
		var doneTypingInterval = 1000;  //time in ms, 1 second for example

		if(typeof options.input_id == 'undefined') {
			options.input_id = "#MembersProfilePlaceId";
		}

		if(typeof options.country_id == 'undefined') {
			options.country_id = "#CountryId";
		}

		var input_id = $(options.input_id);

		//on keyup, start the countdown
		input.on('keyup', function () {
		var searchStr = $(this).val();
		var country_id = $(options.country_id+' option:selected');

		clearTimeout(typingTimer);
		typingTimer = setTimeout(function() {doneTyping(searchStr, country_id); }, doneTypingInterval);
		});

		//on keydown, clear the countdown
		input.on('keydown', function () {
		clearTimeout(typingTimer);
		});

		input.on('focusout', function () {
			if ($(options.input_id).val().length < 1) {
				$(this).val("");
			}

			if (
				typeof $(this).data("tmp-value") != 'undefined' &&
				$(this).data("tmp-value").length > 0 &&
				$(this).val().length > 0
			) {
				var tmp_val = $(this).data("tmp-value");
				$(this).val(tmp_val);
			}
		});

		function checkForExistingPlaces (params) {
			//console.log("checkForExistingPlaces");
			//console.log(params.componentRestrictions.country);
			//console.log("/questions/search_existing_place_name/"+encodeURIComponent(params.input));
			$.post("/questions/search_existing_place_name/"+encodeURIComponent(params.input), function( data ) {
				console.log("data.predictions.length", data.predictions.length);
				if(data.status == "ok" && data.predictions.length > 0) {
			  		updatePredictions(data.predictions, "OK");
			    } else {
			    	autocompleteService.getPlacePredictions(params, updatePredictions);
			    }
			}).fail(function() {
			   autocompleteService.getPlacePredictions(params, updatePredictions);
			});
		}

		//user is "finished typing"
		function doneTyping (searchStr, country_id) {

			$(options.input_id).val("");

			if (searchStr.length > 0) {
				var params = {
					input: searchStr,
					types: ['(regions)']
				};

				if (typeof country_id.data('country') != 'undefined' && country_id.data('country').length > 0) {
					params.componentRestrictions = {country: country_id.data('country')}
				}

				checkForExistingPlaces(params);
			} else {
				$(options.input_id).val("");
				predictionsDropDown.hide();
			}
		}

		predictionsDropDown.delegate('div', 'click', function() {
			input.val($(this).text());
			input_id.val($(this).data('place_id'));
			predictionsDropDown.hide();
		});

		$(document).mouseup(function (e) {
			if (!predictionsDropDown.is(e.target) && predictionsDropDown.has(e.target).length === 0) {
				predictionsDropDown.hide();
			}
		});

		$(window).resize(function() {
			updatePredictionsDropDownDisplay(predictionsDropDown, input);
		});

		updatePredictionsDropDownDisplay(predictionsDropDown, input);

		function updatePredictions(predictions, status) {
			if (google.maps.places.PlacesServiceStatus.OK != status) {
				predictionsDropDown.hide();
				return;
			}

			predictionsDropDown.empty();

			var first_valid_val = false;
			var valid_terms = [];

			var country = false;
			var country_id = $(options.country_id+' option:selected');
			if (typeof country_id.data('country') != 'undefined' && country_id.data('country').length > 0) {
				country = country_id.data('country');
			}

			$.each(predictions, function(i, prediction) {

				//console.log(prediction);

				var div_class = '';
				var valid_type = true;

				if(country == 'lv') { // LV rādīt tikai Novadus un pilsētas
					valid_type = false;
					$.each(prediction.types, function(i, type) {
						if(type == 'administrative_area_level_1' || type == 'administrative_area_level_2') {
							valid_type = true;
						}
					});
				} else { // !LV nerādīt noteiktus place tipus
					$.each(prediction.types, function(i, type) {
						if(type == 'postal_code' || type == 'country' || type == 'sublocality_level_2') {
							valid_type = false;
						}

						if(
							type == 'sublocality' &&
							(typeof op.city_autocomplete_hide_sublocality == 'undefined' ||
							op.city_autocomplete_hide_sublocality == true)
						) {
							valid_type = false;
						}
					});
				}

				if(valid_type == true && !valid_terms.includes(prediction.terms[0].value)) {
					valid_terms.push(prediction.terms[0].value);

					predictionsDropDown.append('<div class="'+div_class+'" data-place_id='+prediction.place_id+'>' + prediction.terms[0].value + '</div>');

					if(first_valid_val == false) {
						//pirms izvēlās no dropdown lista īsto vērtību iesetot pirmo
						div_class = 'active';
						$(options.input_id).val(prediction.place_id);

						// vērtība uz kuru focusout gadījumā nomainīs autocomplete input
						input.data('tmp-value', prediction.terms[0].value);

						// lai nesanāk nesakritība starp place_id un title ja vairs nav focus
						if(!input.is(":focus")) {
							input.val(prediction.terms[0].value);
						}

						first_valid_val = true;
					}
				}
			});

			predictionsDropDown.show();
		}

		return input;
	};

	$.fn.cityAutocomplete.transliterate = function (s) {
		s = String(s);

		var char_map = {
			// Latin
			'À': 'A', 'Á': 'A', 'Â': 'A', 'Ã': 'A', 'Ä': 'A', 'Å': 'A', 'Æ': 'AE', 'Ç': 'C',
			'È': 'E', 'É': 'E', 'Ê': 'E', 'Ë': 'E', 'Ì': 'I', 'Í': 'I', 'Î': 'I', 'Ï': 'I',
			'Ð': 'D', 'Ñ': 'N', 'Ò': 'O', 'Ó': 'O', 'Ô': 'O', 'Õ': 'O', 'Ö': 'O', 'Ő': 'O',
			'Ø': 'O', 'Ù': 'U', 'Ú': 'U', 'Û': 'U', 'Ü': 'U', 'Ű': 'U', 'Ý': 'Y', 'Þ': 'TH',
			'ß': 'ss',
			'à': 'a', 'á': 'a', 'â': 'a', 'ã': 'a', 'ä': 'a', 'å': 'a', 'æ': 'ae', 'ç': 'c',
			'è': 'e', 'é': 'e', 'ê': 'e', 'ë': 'e', 'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i',
			'ð': 'd', 'ñ': 'n', 'ò': 'o', 'ó': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o', 'ő': 'o',
			'ø': 'o', 'ù': 'u', 'ú': 'u', 'û': 'u', 'ü': 'u', 'ű': 'u', 'ý': 'y', 'þ': 'th',
			'ÿ': 'y',

			// Latin symbols
			'©': '(c)',

			// Greek
			'Α': 'A', 'Β': 'B', 'Γ': 'G', 'Δ': 'D', 'Ε': 'E', 'Ζ': 'Z', 'Η': 'H', 'Θ': '8',
			'Ι': 'I', 'Κ': 'K', 'Λ': 'L', 'Μ': 'M', 'Ν': 'N', 'Ξ': '3', 'Ο': 'O', 'Π': 'P',
			'Ρ': 'R', 'Σ': 'S', 'Τ': 'T', 'Υ': 'Y', 'Φ': 'F', 'Χ': 'X', 'Ψ': 'PS', 'Ω': 'W',
			'Ά': 'A', 'Έ': 'E', 'Ί': 'I', 'Ό': 'O', 'Ύ': 'Y', 'Ή': 'H', 'Ώ': 'W', 'Ϊ': 'I',
			'Ϋ': 'Y',
			'α': 'a', 'β': 'b', 'γ': 'g', 'δ': 'd', 'ε': 'e', 'ζ': 'z', 'η': 'h', 'θ': '8',
			'ι': 'i', 'κ': 'k', 'λ': 'l', 'μ': 'm', 'ν': 'n', 'ξ': '3', 'ο': 'o', 'π': 'p',
			'ρ': 'r', 'σ': 's', 'τ': 't', 'υ': 'y', 'φ': 'f', 'χ': 'x', 'ψ': 'ps', 'ω': 'w',
			'ά': 'a', 'έ': 'e', 'ί': 'i', 'ό': 'o', 'ύ': 'y', 'ή': 'h', 'ώ': 'w', 'ς': 's',
			'ϊ': 'i', 'ΰ': 'y', 'ϋ': 'y', 'ΐ': 'i',

			// Turkish
			'Ş': 'S', 'İ': 'I', 'Ç': 'C', 'Ü': 'U', 'Ö': 'O', 'Ğ': 'G',
			'ş': 's', 'ı': 'i', 'ç': 'c', 'ü': 'u', 'ö': 'o', 'ğ': 'g',

			// Russian
			'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D', 'Е': 'E', 'Ё': 'Yo', 'Ж': 'Zh',
			'З': 'Z', 'И': 'I', 'Й': 'J', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N', 'О': 'O',
			'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U', 'Ф': 'F', 'Х': 'H', 'Ц': 'C',
			'Ч': 'Ch', 'Ш': 'Sh', 'Щ': 'Sh', 'Ъ': '', 'Ы': 'Y', 'Ь': '', 'Э': 'E', 'Ю': 'Yu',
			'Я': 'Ya',
			'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'yo', 'ж': 'zh',
			'з': 'z', 'и': 'i', 'й': 'j', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o',
			'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c',
			'ч': 'ch', 'ш': 'sh', 'щ': 'sh', 'ъ': '', 'ы': 'y', 'ь': '', 'э': 'e', 'ю': 'yu',
			'я': 'ya',

			// Ukrainian
			'Є': 'Ye', 'І': 'I', 'Ї': 'Yi', 'Ґ': 'G',
			'є': 'ye', 'і': 'i', 'ї': 'yi', 'ґ': 'g',

			// Czech
			'Č': 'C', 'Ď': 'D', 'Ě': 'E', 'Ň': 'N', 'Ř': 'R', 'Š': 'S', 'Ť': 'T', 'Ů': 'U',
			'Ž': 'Z',
			'č': 'c', 'ď': 'd', 'ě': 'e', 'ň': 'n', 'ř': 'r', 'š': 's', 'ť': 't', 'ů': 'u',
			'ž': 'z', // Polish
			'Ą': 'A', 'Ć': 'C', 'Ę': 'e', 'Ł': 'L', 'Ń': 'N', 'Ó': 'o', 'Ś': 'S', 'Ź': 'Z',
			'Ż': 'Z',
			'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ź': 'z',
			'ż': 'z',

			// Latvian
			'Ā': 'A', 'Č': 'C', 'Ē': 'E', 'Ģ': 'G', 'Ī': 'i', 'Ķ': 'k', 'Ļ': 'L', 'Ņ': 'N',
			'Š': 'S', 'Ū': 'u', 'Ž': 'Z',
			'ā': 'a', 'č': 'c', 'ē': 'e', 'ģ': 'g', 'ī': 'i', 'ķ': 'k', 'ļ': 'l', 'ņ': 'n',
			'š': 's', 'ū': 'u', 'ž': 'z'
		};

		for (var k in char_map) {
			s = s.replace(new RegExp(k, 'g'), char_map[k]);
		}

		return s;
	};

}( jQuery ));
